import { render, staticRenderFns } from "./beneficiary-form.component.vue?vue&type=template&id=8cd795c6&"
import script from "./beneficiary-form.component.vue?vue&type=script&lang=ts&"
export * from "./beneficiary-form.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports